import React from 'react';
import moment from 'moment';
import { ValidReportContainer } from 'containers/SubmissionReports';
import DownloadIcon from 'components/icons/DownloadIcon';
import Table, {THead, TBody, Tr, Td, Th } from 'components/UIKit/Table';
import { uniqueCases } from 'utils/transactions';

let TransactionTypes = ({ tx, groupedByType }) => {
  let groupedByTypeKeys = Object.keys(groupedByType);
  if (!groupedByTypeKeys.length) return <div>No types affected in this transaction.</div>;

  return (
    <span>
      {!!groupedByTypeKeys.length && tx.state === 'SUCCEEDED' &&
        (tx.type === 'upload' || tx.type === 'submit' || tx.type === 'process' || tx.type === 'delete') &&
        <div style={{textAlign: 'right'}}>
          <ValidReportContainer
            customDataTestID="button-download-detailed-report"
            filename={`${tx.type}_report_${moment(tx.created_datetime).format('YYYYMMDDHHmm')}.tsv`}
            entities={ (tx.documents || []).reduce((acc, d) => [...acc, ...d.response.entities], []) }
            style={{cursor: 'pointer'}}
          >
            <a>
              <DownloadIcon />
              Download Detailed Report
            </a>
          </ValidReportContainer>

          <Table customDataTestID="table-transaction-types" style={{border: '1px solid #e5e5e5'}}>
            <THead>
              <Tr>
                <Th>Type</Th>
                <Th style={{textAlign: 'right', width: '4rem'}}>Cases<br/>Affected</Th>
                {tx.type === 'upload' && [
                  <Th key="one" style={{textAlign: 'right', width: '4rem'}}>Entities<br/>Created</Th>,
                  <Th key="two" style={{textAlign: 'right', width: '4rem'}}>Entities<br/>Updated</Th>
                ]}
                {tx.type === 'release' && (
                  <Th style={{textAlign: 'right', width: '4rem'}}>Entities<br/>Released</Th>
                )}
                {tx.type === 'delete' && (
                  <Th style={{textAlign: 'right', width: '4rem'}}>Entities<br/>Deleted</Th>
                )}
              </Tr>
            </THead>
            <TBody>
              {groupedByTypeKeys.map(type =>
                <Tr key={type}>
                  <Td style={{textAlign: 'left', textTransform: 'capitalize'}}>{type}</Td>
                  <Td style={{textAlign: 'right'}}>
                    {type === 'case' ? (groupedByType[type].ids || []).length : uniqueCases([groupedByType[type]])}
                  </Td>
                  {tx.type === 'upload' && [
                    <Td key="one" style={{textAlign: 'right'}}>{groupedByType[type].create || 0}</Td>,
                    <Td key="two" style={{textAlign: 'right'}}>{groupedByType[type].update || 0}</Td>
                  ]}
                  {tx.type === 'release' && (
                    <Td style={{textAlign: 'right'}}>{groupedByType[type].release || 0}</Td>
                  )}
                  {tx.type === 'delete' && (
                    <Td style={{textAlign: 'right'}}>{groupedByType[type].delete || 0}</Td>
                  )}
                </Tr>
              )}
            </TBody>
          </Table>
        </div>
      }
    </span>
  );
};

export default TransactionTypes;
